import { newToolFilterOAuthMcp } from "../oauth.ts";

export const invideoMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://invideo.io/apple-touch-icon.png",
  url: "https://mcp.invideo.io/mcp",
  label: "Invideo",
});
